if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.localization-panel'),
        };
        this.elements.button?.addEventListener('click', this.openSelector.bind(this));
        this.elements.panel?.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        document.addEventListener('click', this.closeSelector.bind(this));
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        const isExpanded = this.elements.button.getAttribute('aria-expanded') === 'true';
        this.elements.button.setAttribute('aria-expanded', !isExpanded);
        if (isExpanded) {
          this.elements.panel.setAttribute('hidden', true);
        } else {
          this.elements.panel.removeAttribute('hidden');
        }
      }

      closeSelector(event) {
        const shouldClose =
          event.target.closest('localization-form') !== this.closest('localization-form');
        if (shouldClose) this.hidePanel();
      }
    }
  );
}
